// header.js
// Motion + header behavior for the "Editorial Quiet" design. Three behaviors,
// all dependency-free and degrade gracefully (reduced-motion: [data-reveal] is
// handled in CSS, the parallax guards itself below):
//
//   1. Scroll reveal — [data-reveal] elements fade/translate up as they enter
//      the viewport, via IntersectionObserver. Plus an on-load in-view sweep so
//      above-the-fold content (the hero) reveals immediately instead of getting
//      stuck invisible. (Both are needed — the sweep fixes a real ATF bug.)
//   2. Header state — past 40px of scroll, toggle `.scrolled` on #top. All the
//      resulting visuals (cream bar, hairline rule, height shrink, colour swap)
//      are CSS keyed off #top.scrolled in index.css, so this only toggles a class.
//   3. Hero parallax (md+) — gently translate the .parallax layer while the hero
//      is in view. No-ops on pages without a hero (the element won't exist).

function revealInView() {
  // Reveal anything already within ~viewport height (covers above-the-fold).
  document.querySelectorAll("[data-reveal]").forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight * 0.96) {
      el.classList.add("in")
    }
  })
}

export function initHeader() {
  // ── 1. Scroll reveal ──
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          // Defer one frame so the start state paints before transitioning.
          requestAnimationFrame(() => e.target.classList.add("in"))
          io.unobserve(e.target)
        }
      })
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  )
  document.querySelectorAll("[data-reveal]").forEach((el) => io.observe(el))
  // Robust above-the-fold reveal: paint initial state, then reveal in-view items.
  requestAnimationFrame(() => requestAnimationFrame(revealInView))
  window.addEventListener("load", revealInView)
  setTimeout(revealInView, 200)

  // ── 2. Header state + 3. Hero parallax ──
  const top = document.getElementById("top")
  // Honour prefers-reduced-motion for the parallax. The CSS handles [data-reveal],
  // but this transform is applied from JS, so it needs its own guard — without it
  // the hero still slid for people who asked the OS for reduced motion.
  const wantsLessMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  const para = wantsLessMotion ? null : document.querySelector(".parallax")
  let ticking = false

  function onScroll() {
    const y = window.scrollY
    if (top) top.classList.toggle("scrolled", y > 40)
    // Parallax only while the hero is on screen; guarded so it no-ops off-home.
    if (para && y < window.innerHeight) {
      para.style.transform = `translateY(${y * 0.06}px)`
    }
    ticking = false
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll)
        ticking = true
      }
    },
    { passive: true }
  )
  onScroll()
}
